import { Group, Header, SimpleCell } from '@vkontakte/vkui';

function ErrorBlock({ message }) {
    return (
        <Group header={<Header mode="secondary">Ошибка</Header>}>
            <SimpleCell style={{ color: 'red' }}>{message}</SimpleCell>
        </Group>
    );
}

export default ErrorBlock;
